export default [
	{
		path: "/pros/integrations",
		exact: true,
		policy: "providerAuth",
		component: "Integrations",
		mui: true,
	},
];
